import axios from "axios";

// In production the frontend and API are co-located behind nginx, so an
// empty/unset REACT_APP_BACKEND_URL is correct — it produces a relative /api
// base that resolves to the same origin.  Only warn in development.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
if (process.env.NODE_ENV === "development" && !BACKEND_URL) {
  console.warn("REACT_APP_BACKEND_URL is not set — using relative /api path");
}
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API_BASE,
  // Required for the browser to send the HttpOnly session_token cookie
  // on cross-origin requests to the API.
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    const isIdleExpiry =
      typeof detail === "string" &&
      detail.toLowerCase().includes("inactiv");
    if (status === 401 && typeof window !== "undefined") {
      const url = window.location.pathname;
      if (url !== "/login") {
        const reason = isIdleExpiry ? "?reason=idle" : "";
        window.location.href = `/login${reason}`;
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail?.msg && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
